import styled from "@emotion/styled";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

// const formats = ["bold", "italic"];
// const quillConfig = {
//   formats,
//   modules: {
//     toolbar: formats,
//   },
//   theme: "bubble",
// } as const;

// HACK: React-Quill v2 has TypeScript support, but has a strange bug where the editor
// disappears on re-renders. For the sake of time, I rolled back to v1.3.5 but have to
// add these crappy copies of the types.
type UnprivelegedEditor = {
  getLength(): number;
  getText(index?: number, length?: number): string;
  getHTML(): string;
  // getBounds(index: number, length?: number): BoundsStatic;
  // getSelection(focus?: boolean): RangeStatic;
  // getContents(index?: number, length?: number): DeltaStatic;
};

type ReactQuillProps = {
  // bounds?: string | HTMLElement
  children?: React.ReactElement;
  className?: string;
  defaultValue?: string;
  formats?: string[];
  id?: string;
  modules?: {
    toolbar: string;
  };
  onChange?(
    value: string,
    delta: unknown,
    source: string,
    editor: UnprivelegedEditor
  ): void;
  // onChangeSelection
  // onFocus
  // onBlur
  // onKeyDown
  // onKeyPress
  // onKeyUp
  placeholder?: string;
  preserveWhitespace?: boolean;
  readOnly?: boolean;
  style?: React.CSSProperties;
  tabIndex?: number;
  theme?: string;
  value?: string;
};

type RichTextEditorProps = Omit<
  ReactQuillProps,
  "children" | "formats" | "modules" | "theme"
>;

function RichTextEditor(props: RichTextEditorProps) {
  return (
    <ReactQuill
      formats={["bold", "italic"]}
      modules={{ toolbar: ["bold", "italic"] }}
      theme="bubble"
      {...props}
    >
      <EditorInput />
    </ReactQuill>
  );
}

const EditorInput = styled.div(({ theme }) => ({
  ".ql-editor": {
    background: theme.colors.bg,
    border: `1px solid ${theme.colors.fg30}`,
    borderBottomColor: theme.colors.fg60,
    color: theme.colors.fg,
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: 1.3,
    margin: "0.5rem 0 0",
    padding: "1rem 1.2rem 1.8rem",
  },
  // Placeholder text
  ".ql-editor::before": {
    left: "1.2rem",
  },
}));

type RichTextProps = Pick<ReactQuillProps, "value" | "className">;

function RichText({ value, className }: RichTextProps) {
  return (
    <ReadOnly
      dangerouslySetInnerHTML={{ __html: value ?? "" }}
      className={className}
    />
  );
}

const ReadOnly = styled.div(({ theme }) => ({
  color: theme.colors.bodyColor,
  fontSize: theme.fontSizes.xs,
  // prevents bad paragraph spacing due to lack of soft returns in editor
  p: { margin: 0 },
  "p:has(br:only-child)+p:has(br:only-child)": {
    display: "none",
  },
}));

export { RichText, RichTextEditor };
